<template>
  <div v-if="!isLoadingInit">
    <b-card v-for="(buildingLot, index) in sortedBuildingLots" :key="index" class="my-5">
      <appBuildingLot
        :building-lot="buildingLot"
        :building-id="buildingId"
        :voting-categories="votingCategories"
        :building-owner="buildingOwner"
        :building-owner-voting-rights="buildingOwnerVotingRights"
        @CREATE_VOTING_CATEGORY="CREATE_VOTING_CATEGORY($event)"
        @CREATE_VOTING_RIGHT="CREATE_VOTING_RIGHT($event)"
        @updateBuildingOwner="updateBuildingOwner"
      />
    </b-card>
  </div>
  <appLoader v-else />
</template>

<script>
import appBuildingLot from "./Step3BuildingLot";

import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";
import VotingCategoryMW from "@/middlewares/VotingCategory";

import BuildingOwnerVotingRightORM from "@/store/orm-axios/models/BuildingOwnerVotingRight";
import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";
import BuildingLotMW from "@/middlewares/BuildingLot";

var uuid = require("uuid");

export default {
  components: {
    appBuildingLot,
  },
  props: {
    buildingOwner: {
      type: Object,
      default: () => {
        return {};
      },
    },
    buildingId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoadingInit: true,
      voting_categories: [],
      buildingOwnerHasVotingRight: [],
      buildingOwnerVotingRights: [],
    };
  },
  computed: {
    votingCategories() {
      let apiVotingCategories = VotingCategoryORM.query()
        .where("agency_id", this.agencyId)
        .where("building_id", this.buildingId)
        .get();
      return apiVotingCategories.concat(this.voting_categories);
    },
    buildingLots() {
      return BuildingLotORM.query()
        .where("agency_id", this.agencyId)
        .where("building_id", this.buildingId)
        .with("building_owner_building_lots")
        .get();
    },
    computedBuildingOwnerVotingRights() {
      let buildingOwnerVotingRight = [];
      this.$_.each(this.buildingOwner.building_lots, buildingLot => {
        if (buildingLot.pivot) {
          let item = BuildingOwnerVotingRightORM.query()
            .where("building_owner_has_building_lot_id", buildingLot.pivot.id)
            .get();
          if (item.length == 1) {
            buildingOwnerVotingRight.push(item[0]);
          } else if (item.length > 1) {
            buildingOwnerVotingRight = buildingOwnerVotingRight.concat(item);
          }
        } else {
          let item = BuildingOwnerVotingRightORM.query()
            .where(
              "building_owner_has_building_lot_id",
              buildingLot.building_owner_building_lots[0].id
            )
            .get();
          if (item.length == 1) {
            buildingOwnerVotingRight.push(item[0]);
          } else if (item.length > 1) {
            buildingOwnerVotingRight = buildingOwnerVotingRight.concat(item);
          }
        }
      });
      return buildingOwnerVotingRight;
    },
    sortedBuildingLots() {
      return this.sortArr(this.buildingOwner.building_lots);
    },
  },
  async created() {
    // NOTE: get join table data
    if (this.buildingOwner.id) {
      await VotingCategoryMW.FETCH(this.buildingId);
      if (this.buildingOwner.building_lots.length == 0) {
        await BuildingLotMW.FETCH(this.buildingId);
        this.$emit("updateBuildingOwner", "building_lots", this.buildingLots);
      }

      this.isLoadingInit = false;
    } else {
      this.isLoadingInit = false;
    }
    if (this.buildingOwner.building_owner_has_voting_rights) {
      this.buildingOwnerVotingRights = this.buildingOwner.building_owner_has_voting_rights;
    } else {
      this.buildingOwnerVotingRights = this.computedBuildingOwnerVotingRights;
      this.$emit(
        "updateBuildingOwner",
        "building_owner_has_voting_rights",
        this.buildingOwnerVotingRights
      );
    }
  },
  methods: {
    updateBuildingOwner(key, value) {
      this.$emit("updateBuildingOwner", key, value);
    },
    // NOTE: create voting category, then create voting right belonging to that voting category and join table
    CREATE_VOTING_CATEGORY(obj) {
      let votingCategoryId = uuid.v4();
      this.voting_categories.push({
        id: votingCategoryId,
        name: obj.votingCategory.name,
        is_charge_general: 0,
      });
      this.buildingOwnerVotingRights.push({
        building_owner_building_lot_id: obj.buildingOwnerBuildingLotId,
        voting_category_id: votingCategoryId,
        parts: 0,
      });
      this.updateBuildingOwner("voting_categories", this.voting_categories);
      this.updateBuildingOwner("building_owner_has_voting_rights", this.buildingOwnerVotingRights);
    },
    // NOTE: create voting right belonging to a voting category and join table
    CREATE_VOTING_RIGHT(obj) {
      this.buildingOwnerVotingRights.push({
        building_owner_has_building_lot_id: obj.buildingOwnerBuildingLotId,
        voting_category_id: obj.votingCategoryId,
        parts: 0,
      });
      this.updateBuildingOwner("building_owner_has_voting_rights", this.buildingOwnerVotingRights);
    },
    sortArr(arr) {
      // NOTE: Filter and sort only the strings that are numbers
      let numArr = arr
        .filter(el => el.name != "" && !isNaN(el.name))
        .sort((a, b) => Number(a.name) - Number(b.name));

      // NOTE: Filter and sort only the strings
      let strArr = arr.filter(el => isNaN(el.name)).sort();

      return numArr.concat(strArr);
    },
  },
};
</script>
